export default {"src":"/_next/static/media/Menstrual Disorders.0d60c837.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};